"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _MapEvented2 = _interopRequireDefault(require("./MapEvented"));

var MapComponent =
/*#__PURE__*/
function (_MapEvented) {
  (0, _inheritsLoose2.default)(MapComponent, _MapEvented);

  function MapComponent() {
    return _MapEvented.apply(this, arguments) || this;
  }

  var _proto = MapComponent.prototype;

  _proto.getOptions = function getOptions(props) {
    if (props.pane != null) {
      return props;
    }

    if (props.leaflet != null && props.leaflet.pane != null) {
      return (0, _extends2.default)({}, props, {
        pane: props.leaflet.pane
      });
    }

    return props;
  };

  return MapComponent;
}(_MapEvented2.default);

exports.default = MapComponent;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-leaflet/lib/MapComponent.js
 ** module id = 200
 ** module chunks = 0
 **/